import React, { useEffect, useRef } from 'react';

import { useNode } from '@craftjs/core';

import PropTypes from 'prop-types';
import { EDITOR_RESOLVERS } from '@common/constants';
import { getFlex } from '@common/helpers/domManipulationHelpers';

import { useTemplateConfig } from './TemplateContext';
import SettingsWrapper from '@common/components/SettingsWrapper/SettingsWrapper';

import FlexAlignment from '@resolvers/tools/FlexAlignment/FlexAlignment';

const getBodySize = ({ showHeader, showFooter, headersSize, pageHeight }) => {
  return (
    Number(pageHeight || 100) -
    (showHeader ? Number(headersSize?.standard?.header || 10) : 0) -
    (showFooter ? Number(headersSize?.standard?.footer || 10) : 0)
  );
};

const PageBody = ({
  children,
  flexDirection,
  flexOrder,
  justifyContent,
  alignItems,
}) => {
  const { showHeader, showFooter, pageSize } = useTemplateConfig();

  const {
    connectors: { connect, drag },
    actions: { setCustom },
  } = useNode();
  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current && connect) {
      connect(drag(ref.current));
    }
  }, [connect]);

  const bodyHeight = getBodySize({
    showHeader,
    showFooter,
    headersSize: pageSize?.headersSize,
    pageHeight: pageSize?.height,
  });

  const flexValues = getFlex({ flexDirection, flexOrder });

  return (
    <div
      className='page-body'
      style={{
        height: `${bodyHeight || 250}px`,
        width: pageSize.width ? `${pageSize.width}px` : undefined,
        rowGap: 0,
        columnGap: 0,
        gap: 0,
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
        justifyContent,
        alignItems,
        // overflowH: 'hidden',
        overflow: 'hidden',
        ...flexValues,
      }}
      ref={ref}
    >
      {children}
    </div>
  );
};

const PageBodyConfigPanel = () => {
  return (
    <SettingsWrapper>
      <FlexAlignment hideElements={{ flexDirection: true }} />
    </SettingsWrapper>
  );
};

export const PageBodyDefaultProps = {
  background: '#ffffff',
  paddingLeft: '5',
  paddingRight: '5',
  paddingTop: '5',
  paddingBottom: '5',
  children: null,
  flexDirection: 'column',
  justifyContent: 'flex-start',
  flexOrder: 'normal',
  alignItems: 'flex-start',
};

PageBody.propTypes = {
  background: PropTypes.string,
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  children: PropTypes.node,
  flexDirection: PropTypes.string,
  flexOrder: PropTypes.string,
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
};

PageBody.craft = {
  displayName: EDITOR_RESOLVERS.PDF.PAGE_BODY,
  name: EDITOR_RESOLVERS.PDF.PAGE_BODY,
  props: PageBodyDefaultProps,
  related: {
    settings: PageBodyConfigPanel,
  },
};

export default PageBody;
